import { render, staticRenderFns } from "./AccountQuestion.vue?vue&type=template&id=efe189c0"
import script from "./AccountQuestion.vue?vue&type=script&lang=js"
export * from "./AccountQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports